<template>
  <div>
    <h1>Nie prowadzimy obecnie żadnych zapisów pod tym adresem.</h1>
    <div>O poprawny url do zapisów na wydarzenie spytaj organizatorów.</div>
  </div>
</template>

<script>
export default {
  name: 'NoSuchEvent'
}
</script>

<style scoped></style>
